import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalService } from '../providers/global.service';
import { Constants } from '../models/open-app/constants.model';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class ConfigConstantsService extends RequestService<Constants> {
  static PATH = '/config/constants';
  constructor(
    public override httpClient: HttpClient,
    public globalService: GlobalService,
  ) {
    super(httpClient, ConfigConstantsService.PATH, globalService.debugUrl);
  }
}
